var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col col-md-6 mt-4"},[(_vm.didConsumeToken)?_c('Card',{attrs:{"bgclass":_vm.card_bgclass,"textclass":_vm.card_textclass,"header":_vm.card_header,"title":_vm.card_title,"text":_vm.card_text}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }